import { FormikProps } from "formik";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import MobilePhoneInfo from "./MobilePhoneInfo";
import { FormWithPhones } from "../../../../domain/models/dto/PhoneDTO";
import DesktopPhoneInfo from "./DesktopPhoneInfo";
import { Fragment } from "react/jsx-runtime";
import { Fields } from "../../../../types/SchemaFactory";

interface PhoneInfoProps<T> {
    form: FormikProps<T>;
    fields: Fields<T>;
}

function PhoneInfo<T extends FormWithPhones>(props: PhoneInfoProps<T>) {
    const { upTo1024 } = useScreenSize();
    const viberCheckboxHandler = (index: number) => {
        return () => {
            props.form.setFieldValue(`phones[${index}].viber`, !props.form.values.phones[index].viber);
        };
    };
    const whatsappCheckboxHandler = (index: number) => {
        return () => {
            props.form.setFieldValue(`phones[${index}].whatsapp`, !props.form.values.phones[index].whatsapp);
        };
    };

    return (
        <div className="relative w-full">
            {props.form.values.phones.map((value, index) => (
                <Fragment key={"phone-info-component-" + index}>
                    {upTo1024 ? (
                        <MobilePhoneInfo
                            form={props.form}
                            fields={props.fields}
                            value={value}
                            index={index}
                            viberCheckboxHandler={viberCheckboxHandler}
                            whatsappCheckboxHandler={whatsappCheckboxHandler}
                        />
                    ) : (
                        <DesktopPhoneInfo
                            form={props.form}
                            fields={props.fields}
                            value={value}
                            index={index}
                            viberCheckboxHandler={viberCheckboxHandler}
                            whatsappCheckboxHandler={whatsappCheckboxHandler}
                        />
                    )}
                </Fragment>
            ))}
        </div>
    );
}

export default PhoneInfo;
